import React from "react";
import { BreadCrumbsProps } from "../types/CommonTypes";

const BreadCrumbs: React.FC<BreadCrumbsProps> = ({ title, description }) => {
  return (
    <section className="breadcrumbs">
      <div className="breadcrumb-sm-images">
        <div className="inner-banner-1 magnetic-item">
          <img
            src="https://appthing-website.s3.ap-south-1.amazonaws.com/inner-banner-1.png"
            alt="banner1"
            height={120}
          />
        </div>
        <div className="inner-banner-2 magnetic-item">
          <img
            src="https://appthing-website.s3.ap-south-1.amazonaws.com/inner-banner-2.png"
            alt="banner2"
            height={100}
          />
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="breadcrumb-wrapper">
              <div className="breadcrumb-cnt">
                <span>{title}</span>
                <p className="breadcrumbDescription">{description}</p>
                <div className="breadcrumb-list">
                  <a href="/">Home</a>
                  <img
                    src="https://appthing-website.s3.ap-south-1.amazonaws.com/breadcrumb-arrow.svg"
                    alt="breadcrumb"
                  />
                  {title}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BreadCrumbs;
